import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "col-12 text-left" }
const _hoisted_3 = { class: "ml-5 mt-2 mb-5" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Manufacture")
], -1)
const _hoisted_6 = { class: "col-12 col-lg-6 text-uppercase" }
const _hoisted_7 = { class: "row w-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 mt-2 mt-lg-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Model")
], -1)
const _hoisted_9 = { class: "col-12 col-lg-6 text-uppercase" }
const _hoisted_10 = { class: "row w-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 mt-2 mt-lg-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Date Manufacture")
], -1)
const _hoisted_12 = { class: "col-12 col-lg-6" }
const _hoisted_13 = { class: "row w-100" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 mt-2 mt-lg-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Serial Number")
], -1)
const _hoisted_15 = { class: "col-12 col-lg-6 text-uppercase" }
const _hoisted_16 = { class: "row w-100" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 mt-2 mt-lg-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Measurement")
], -1)
const _hoisted_18 = { class: "col-12 col-lg-6 text-capitalize" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "row w-100" }
const _hoisted_21 = { class: "col-12 col-lg-6 mt-2 mt-lg-1" }
const _hoisted_22 = { class: "font-weight-bold" }
const _hoisted_23 = { class: "col-12 col-lg-6 text-uppercase" }
const _hoisted_24 = { class: "row w-100" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 mt-2 mt-lg-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Configuration")
], -1)
const _hoisted_26 = { class: "col-12 col-lg-6" }
const _hoisted_27 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.equipment.manufacturer), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.equipment.model), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.equipment.date_manufactured)), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.equipment.serial_number), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.measurements, (i, indexMeasurement) => {
              return (_openBlock(), _createElementBlock("span", { key: indexMeasurement }, [
                _createTextVNode(_toDisplayString(i) + " ", 1),
                (indexMeasurement != _ctx.equipment.measurements.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, " , "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.equipment?.custom_field?.value ?? []), (customField) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(customField.label), 1)
            ]),
            _createElementVNode("div", _hoisted_23, _toDisplayString(customField.value), 1)
          ]))
        }), 256)),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.configurations, (i, indexConfig) => {
              return (_openBlock(), _createElementBlock("span", { key: indexConfig }, [
                _createTextVNode(_toDisplayString(i) + " ", 1),
                (indexConfig != _ctx.equipment.configurations.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, " , "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}